// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1hMcV","disabled":"styles_disabled__1t9t_"};